import parse, { domToReact } from "html-react-parser";
import { MdBookmarkAdded, MdBookmarkBorder } from "react-icons/md";
import SyntaxHighlighter from "react-syntax-highlighter";
import { tomorrowNight } from "react-syntax-highlighter/dist/cjs/styles/hljs";
import { atomDark } from "react-syntax-highlighter/dist/esm/styles/prism";

const QuizBodyQuestion = ({
  answers,
  handleFlagQuestion,
  quizTestsQuestions,
  currentPage,
}) => {
  const questionIndex = Math.max(0,
    Math.min(currentPage, quizTestsQuestions.length - 1),
  );
  const question = quizTestsQuestions?.[questionIndex];
  const questionId = question?._id;

  const isFlagged = (questionId) =>
    answers.some((answer) => answer.questionId === questionId && answer.flag);

  const renderContent = (htmlString) => {
    if (!htmlString) return null;

    return parse(htmlString, {
      replace: (domNode) => {
        if (domNode.name === "pre") {
          const codeContent = domNode.children
            .map(
              (child) =>
                child.data ||
                (child.children
                  ? child.children.map((c) => c.data).join("")
                  : ""),
            )
            .join("\n");

          return (
            <SyntaxHighlighter style={tomorrowNight} language='javascript'>
              {codeContent}
            </SyntaxHighlighter>
          );
        }
      },
    });
  };

  return (
    <section className='text-white rounded'>
      <div className='d-flex justify-content-between align-items-center mb-3'>
        <h5 className='fw-semibold'>Question {questionIndex + 1} / {quizTestsQuestions.length}</h5>
        <button
          onClick={() => handleFlagQuestion(questionId)}
          className={`btn btn-sm d-flex align-items-center gap-2 ${
            isFlagged(questionId) ? "text-primary" : "text-muted"
          }`}
        >
          {isFlagged(questionId) ? (
            <MdBookmarkAdded size={20} />
          ) : (
            <MdBookmarkBorder size={20} />
          )}
          <span className='fw-medium'>Revisit Later</span>
        </button>
      </div>
      <div className='fs-5 quiz-question'>
        {question?.title && renderContent(question.title)}
      </div>
    </section>
  );
};

export default QuizBodyQuestion;
